import script from "./AdminPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminPage.vue?vue&type=script&setup=true&lang=ts"

import "./AdminPage.vue?vue&type=style&index=0&id=bd363bb8&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd363bb8"]])

export default __exports__